module.exports = __webpack_public_path__ + "static/media/arrow_left.4335f226.svg";